import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {API} from "../../app/services/api.service";
import {Customer} from "../../app/classes/customer";
import {COMPLETE_PAYLOAD} from "../../app/constants/config";
import {Http} from "@angular/http";

/*
  Generated class for the MinimumOrderValue page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-minimum-order-value',
  templateUrl: 'minimum-order-value.html'
})
export class MinimumOrderValuePage {
  public customer : Customer;
  public errorMessage : any;
  constructor(private api : API, public navCtrl: NavController, public http: Http, public navParams: NavParams) {
    this.customer = Customer.cachedOrCreate(this.http) as Customer;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MinimumOrderValuePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/minimum-order-value/minimum-order-value.ts